import {
  JOURNEY_PREVIEW_KIND,
  JOURNEY_PREVIEW_FRAGMENT,
} from "./journeyConstants";

const EMPTY_CONTEXT = Object.freeze({
  isAdminPreview: false,
  previewKind: null,
  previewSource: null,
  previewClientId: null,
  previewClientName: null,
  previewProgramId: null,
  previewCustomProgramId: null,
  previewApiBaseUrl: null,
  previewCapabilityToken: null,
  previewSnapshotChecksum: null,
  previewSnapshotId: null,
});

export const getTreatmentLaunchContext = (
  search = "",
  hash = typeof window !== "undefined" ? window.location.hash : "",
) => {
  const params = new URLSearchParams(search);
  const hashParams = new URLSearchParams(
    String(hash || "").replace(/^#/, ""),
  );
  const previewCapabilityToken = hashParams.get(
    JOURNEY_PREVIEW_FRAGMENT.capability,
  );
  const isCapabilityPreview = Boolean(previewCapabilityToken);

  if (isCapabilityPreview) {
    return {
      isAdminPreview: true,
      previewKind: JOURNEY_PREVIEW_KIND.capability,
      previewSource: null,
      previewClientId: null,
      previewClientName: null,
      previewProgramId: "capability",
      previewCustomProgramId: null,
      previewApiBaseUrl: params.get("api_base_url"),
      previewCapabilityToken,
      previewSnapshotChecksum: hashParams.get(
        JOURNEY_PREVIEW_FRAGMENT.snapshotChecksum,
      ),
      previewSnapshotId: hashParams.get(JOURNEY_PREVIEW_FRAGMENT.snapshotId),
    };
  }

  // Mutable query-string preview sources are intentionally ignored. Program,
  // Custom Program, Section, and Consent previews must enter with an opaque
  // capability in the URL fragment.
  return EMPTY_CONTEXT;
};

export const getPreviewBranding = (launchContext) => {
  if (launchContext.previewKind === JOURNEY_PREVIEW_KIND.capability) {
    return { id: "treatment-preview", name: "WellieMD" };
  }
  return null;
};
